import { FirebaseError } from 'firebase/app';

export function authErrorMessage(error: unknown): string {
  const code = error instanceof FirebaseError ? error.code : '';
  switch (code) {
    case 'auth/invalid-credential':
    case 'auth/invalid-email':
    case 'auth/user-not-found':
    case 'auth/wrong-password':
      return 'الإيميل أو كلمة السر غير صحيحة.';
    case 'auth/too-many-requests':
      return 'محاولات كثيرة. المحاولة ممكنة بعد شوي.';
    case 'auth/network-request-failed':
      return 'في مشكلة بالاتصال بالإنترنت. الرجاء المحاولة مرة ثانية.';
    case 'auth/user-disabled':
      return 'هذا الحساب موقوف.';
    default:
      return 'صار خطأ. الرجاء المحاولة مرة ثانية.';
  }
}
